import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ManageKeysPageRoutingModule } from './manage-keys-routing.module';

import { ManageKeysPage } from './manage-keys.page';
import { UiCHeaderPixModule } from '@wlp/ui-c-header-pix';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { UiCButtonModule } from '@wlp/ui-c-button';
import { UiCPixManageKeysModule } from '@wlp/ui-c-pix-manage-keys';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { InterceptService } from 'src/app/core/intercept/intercept.service';
import { ClaimsKeysPixService, RegisterKeyService } from '@wlp/ui-bs-pix';
import { HeaderUserInfoModule } from '@wlp/ui-c-header-user-info';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ManageKeysPageRoutingModule,
    UiCHeaderPixModule,
    UiBsTranslateModule,
    UiCButtonModule,
    HeaderUserInfoModule,
    UiCPixManageKeysModule
  ],
  declarations: [ManageKeysPage],
  providers: [
    RegisterKeyService,
    ClaimsKeysPixService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptService,
      multi: true,
    },
  ]
})
export class ManageKeysPageModule { }
